import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, Typography } from "@mui/material";
import { ChevronDown, Languages } from "lucide-react";

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    i18n.language.split("-")[0] || "en"
  );

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (language: string) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language);
    localStorage.setItem("i18nextLng", language);
    handleMenuClose();
  };

  return (
    <div className="flex items-center cursor-pointer hover:bg-neutral-100 rounded-full p-2">
      <div
        onClick={handleMenuOpen}
        color="inherit"
        className="flex flex-row p-auto text-center align-middle justify-center "
      >
        <Languages />
        <Typography sx={{ color: "primary.main" }}>
          {t(`language.${selectedLanguage}`)}
        </Typography>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => handleLanguageSelect("en")}>English</MenuItem>
        <MenuItem onClick={() => handleLanguageSelect("nl")}>Dutch</MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;
